import { LogicalOperator } from "@financial-advisory/data-access/api-types";
import { LogicalOperatorPill } from "@unlikelyai-magic/shared/components";
import { cn } from "@unlikelyai-magic/utils";

export const GraphLegend = () => {
  return (
    <div className={cn("bg-white flex flex-col gap-2 overflow-y-auto")}>
      <div className="sticky top-0 bg-white flex flex-row items-center justify-between gap-2 border-b border-gray-200 px-3 min-h-[3.375rem]">
        <div className="flex flex-row gap-2">
          <div className="flex flex-row items-center gap-2">
            <LogicalOperatorPill operator={LogicalOperator.AND} />
            <span className="text-sm text-gray-400">
              All conditions must be true
            </span>
          </div>
          <div className="flex flex-row items-center gap-2">
            <LogicalOperatorPill operator={LogicalOperator.OR} />
            <span className="text-sm text-gray-400">
              Any condition can be true
            </span>
          </div>
          <div className="flex flex-row items-center gap-2">
            <LogicalOperatorPill operator={LogicalOperator.NOT} />
            <span className="text-sm text-gray-400">Negates the condition</span>
          </div>
        </div>
      </div>
    </div>
  );
};
